import React from 'react';

const DistributionCenterContext = React.createContext<any>(false);

export default DistributionCenterContext;

